import React from 'react';

/**
 * Bouton + panneau dépliable réutilisé pour "Affiner ce poste" (calcul plus précis) ou pour
 * masquer une information secondaire (ex. barème détaillé) — même pattern visuel filtre déjà
 * présent ailleurs dans le module V2 (apv2-filter-toggle-btn / apv2-filter-panel).
 */
const RefinePanel = ({ open, onToggle, label = 'Affiner ce poste', children }) => (
  <>
    <div className="apv2-filter-toggle-row">
      <button type="button" className="apv2-filter-toggle-btn" onClick={onToggle}>
        {open ? '▾' : '▸'} {label}
      </button>
    </div>
    {open && <div className="apv2-filter-panel rw-refine-panel">{children}</div>}
  </>
);

export default RefinePanel;
